import styled from 'styled-components';

export const SpanStyle = styled.span`
	position: absolute;
	right: -0.313rem;
	bottom: 0;
	z-index: 1;
	width: 0.625rem;
	height: 100%;
	cursor: col-resize;
`;

export const DragSpanStyle = styled.span`
	display: flex;
	margin: -1rem;
	padding: 1rem;
`;
